import { render, staticRenderFns } from "./ClientsCarousel.vue?vue&type=template&id=b2774312&scoped=true&"
import script from "./ClientsCarousel.vue?vue&type=script&lang=js&"
export * from "./ClientsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ClientsCarousel.vue?vue&type=style&index=0&id=b2774312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2774312",
  null
  
)

export default component.exports